// Human-friendly duration formatting for attendance hours.
// Prefer using the `_display` fields the backend now returns
// (e.g. today.accumulated_display, history row's total_hours_display), // these helpers exist as a client-side fallback/consistency check.

/**
 * Format a duration given in seconds into "11m" or "2h 15m" (omits minutes
 * when they're exactly 0, e.g. "2h"). Returns "0m" for zero/invalid input.
 */
export function formatDurationFromSeconds(totalSeconds) {
  const seconds = Math.max(0, Math.round(totalSeconds || 0));
  const totalMinutes = Math.round(seconds / 60);
  if (totalMinutes <= 0) return "0m";
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

/**
 * Same formatting, but from decimal hours (e.g. 2.25 -> "2h 15m").
 */
export function formatDurationFromHours(decimalHours) {
  return formatDurationFromSeconds((parseFloat(decimalHours) || 0) * 3600);
}